// extracted by mini-css-extract-plugin
export var errorIcon = "_l8-1";
export var nameLogo = "_l8-0";